import FormGenerator, { FormTypes } from '../components/FormGenerator';

const demoSteps = [
	{
		id: 1,
		step: 1,
		fieldName: 'membershipType',
		question: 'Membership',
		stepperTitle: 'Membership type',
		instructionText: 'Which membership type are you applying for?',
		errorMessage: 'Please select an option',
		options: [
			{
				id: 'individual',
				label: 'Individual',
				dependentQuestion: [2]
			},
			{
				id: 'family',
				label: 'Family',
				dependentQuestion: [3]
			}
		],
		visible: true,
		questionType: 'radio'
	},
	{
		id: 2,
		step: 1,
		fieldName: 'individualLevel',
		instructionText: 'Select your individual membership level',
		errorMessage: 'Please select a level',
		options: [
			{ id: 'bronze', label: 'Bronze' },
			{ id: 'silver', label: 'Silver' },
			{ id: 'gold', label: 'Gold' }
		],
		visible: false,
		questionType: 'radio'
	},
	{
		id: 3,
		step: 1,
		fieldName: 'familySize',
		instructionText: 'How many family members?',
		errorMessage: 'Please select family size',
		options: [
			{ id: '2', label: '2 members' },
			{ id: '3', label: '3 members' },
			{ id: '4', label: '4+ members' }
		],
		visible: false,
		questionType: 'radio'
	},
	{
		id: 4,
		step: 2,
		fieldName: 'region',
		question: 'Region',
		stepperTitle: 'Your region',
		instructionText: 'Which region are you based in?',
		errorMessage: 'Please select a region',
		placeholder: 'Select a region',
		options: [
			{ id: 'london', label: 'London' },
			{ id: 'south-east', label: 'South East' },
			{ id: 'midlands', label: 'Midlands' },
			{ id: 'north', label: 'North' }
		],
		visible: true,
		questionType: 'select'
	}
];

const initFormGeneratorDemo = () => {
	const container = document.querySelector('#js-form-generator-demo');
	const eventLog = document.querySelector('#js-form-generator-demo-log');

	if (!container) {
		return;
	}

	const formGenerator = new FormGenerator(container, {
		questions: demoSteps,
		totalSteps: 2,
		formType: FormTypes.StepForm,
		themeColor: 'color-lta-blue',
		isHideProgress: false,
		isBackButtonEnabled: true,
		conditionalStepsVisiblity: true,
		submitButton: {
			title: 'Complete'
		}
	});

	formGenerator.onChange(() => {
		if (eventLog) {
			eventLog.textContent = `Event: onChange — step ${formGenerator.currentStep}`;
		}
	});

	formGenerator.onStepChange((step) => {
		if (eventLog) {
			eventLog.textContent = `Event: onStepChange — step ${step}`;
		}
	});

	formGenerator.onSubmit((answers) => {
		if (eventLog) {
			eventLog.textContent = `Event: onSubmit — ${JSON.stringify(answers)}`;
		}
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initFormGeneratorDemo);
} else {
	initFormGeneratorDemo();
}
